import React from "react"
import FullscreenLoader from "../FullscreenLoader/FullscreenLoader"
import { selectIsOmniLoading } from "../../store/app/selectors"
import { useAppSelector } from "../../store/hooks"

const OmniLoader: React.FC = () => {
    const isOmniLoading = useAppSelector(selectIsOmniLoading)

    return isOmniLoading ? <FullscreenLoader hideLogo /> : null
}

export default OmniLoader
